import { styled } from "styled-components";

export const HeaderSection = styled.div`
    position:fixed;
    top:0;
    padding: 1rem 4rem;
    max-height: 100px;
    display: flex;
    justify-content: space-between;
    width: 100vw;
    z-index: 2;
    background-color: #fff;

    @media (max-width: 768px) {
        padding: 0.4rem 0.6rem;
        background: #fff;
        max-height: 70px;
        align-items: center;
    }
`

export const Logo = styled.div`
    display: flex;
    align-items: center;
    .beta {
        display: inline-block;
        font-style: normal;
        background-color: #6288e980;
        color: #fff;
        font-size: 11px;
        padding: 1px 4px;
        border-radius: 4px;
        position: relative;
        top: -25px;
    }

    h2 {
        margin: 0;
    }

    .prototype {
        display: inline-block;
        font-style: normal;
        background-color: #D9D4D4;
        color: #fff;
        font-size: 11px;
        padding: 2px 4px;
        border-radius: 6px;
        font-weight: 400;
        position: absolute;
        top: -4px;
        right: -70px;
    }

    @media (max-width: 768px) {
        h2 {
            margin: 0;
            font-size: 20px;
        }
        a {
            height: 40px;
        }

        .beta {
            top: -50px;
            left: 85%;
        }

        .prototype {
            top: -13px;
            right: -10px;
            padding: 1px 4px;
        }

        h2 {
            // padding: 4px 0;
            font-size: 16px;
        }
    }
`

export const Links = styled.div`
    display:flex;
    align-items: center;

    a {
        padding: 0 20px 10px;
        font-size: 16px;
        text-decoration: none;
        color: #000;
    }

    @media (max-width: 768px) {
        display: none;
    }
`

interface NavProps {
    active:string;
}

export const MobileNav = styled.div<NavProps>`
    display: flex;
    align-items: center;
    gap: 20px;

    & > a {
    display: inline-block;
    text-decoration: none;
    font-size: 1.1em;
    color: #1c0042;
    position: relative;
    transition: all 0.25s ease 0s;
    cursor: pointer;
    position: relative;
    padding: 0 10px;
    }

    @media (max-width: 991px) {
    display: ${({ active }: { active: string }) =>
        active && active === "true" ? "flex" : "none"};
    position: fixed;
    top: 52px;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #fff;
    z-index: 2;
    flex-direction: column;
    align-items: flex-start;
    padding: 1.375rem 0px 0.625rem 3.5rem;

    button {
        margin-bottom: 1.375rem;
        font-size: 1.25rem;
        padding: 0.75rem 2.125rem;
    }

    & > a {
        font-size: 1.25rem;
    }
    }
`

export const NavContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
`

interface ToggleProps {
    active:string;
}

export const MenuToggle = styled.button<ToggleProps>`
  cursor: pointer;
  border: 0 none;
  mask-image: ${({ active }: { active: string }) =>
  active && active === "true"
    ? `url("${process.env.PUBLIC_URL}/images/X.svg")`
    : `url("${process.env.PUBLIC_URL}/images/Menu.svg")`};
  mask-position: 0 0;
  mask-repeat: no-repeat;
  background-color: #888;
  width: 24px;
  height: 24px;
  mask-size: cover;
  margin-right: 0 !important;
  display: inline-block;
  margin-left: 10px;

  @media (min-width: 768px) {
    display: none;
  }
`;